class SubscriptionWidget extends HTMLElement {
  constructor() {
    super();
    this.cartForm = this.closest('cart-form');
  }

  connectedCallback() {
    if (this.cartForm) {
      this.observeCartFormChanges();
    }
    this.initOptions();
    
    const selectedOption = this.querySelector('.subs-button.selected-plan');
    if (selectedOption) {
      this.updateOptionTitle(selectedOption);
      this.updateFormData(selectedOption);
    }
  }

  initOptions() {
    const options = this.querySelectorAll('.subs-button');
    options.forEach(option => {
      option.addEventListener('click', () => this.selectOption(option));
    });
  }

  updateOptionTitle(option) {
    const optionName = option.querySelector('.option-name')?.textContent;
    if (optionName) {
      const optionTitleElement = this.querySelector('#option-title');
      if (optionTitleElement) {
        optionTitleElement.textContent = optionName;
      }
    }
    
    // this.updatePriceDisplay(option);
  }

  // updatePriceDisplay(option) {
  //   const priceElement = option.querySelector('.price-element');
  //   if (priceElement) {
  //     const priceText = priceElement.textContent;
      
  //     const planName = option.getAttribute('data-plan-name');
  //     const quantity = this.parseQuantityFromPlanName(planName);
      
  //     const currencyMatch = priceText.match(/^([^\d]+)/);
  //     const priceMatch = priceText.match(/([\d,.]+)/);
      
  //     if (currencyMatch && priceMatch) {
  //       const currencySymbol = currencyMatch[1];
  //       const priceValue = parseFloat(priceMatch[1].replace(',', ''));
  //       const adjustedPrice = (priceValue * quantity).toFixed(2);
  //       const adjustedPriceText = `${currencySymbol}${adjustedPrice}`;
        
  //       const AtcButton = this.cartForm?.querySelector('.AddToCart .button-label') 
        
  //       if (AtcButton) {
  //         const currentText = AtcButton.textContent;
  //         const label = currentText.split(' - ')[0];
  //         AtcButton.textContent = `${label} - ${adjustedPriceText}`;
  //       }
  //     } else {
  //       const AtcButton = this.cartForm?.querySelector('.AddToCart .button-label') 
        
  //       if (AtcButton) {
  //         const currentText = AtcButton.textContent;
  //         const label = currentText.split(' - ')[0];
  //         AtcButton.textContent = `${label} - ${priceText}`;
  //       }
  //     }
  //   }
  // }

  selectOption(option) {
    const options = this.querySelectorAll('.subs-button');
    options.forEach(opt => opt.classList.remove('selected-plan'));
    option.classList.add('selected-plan');
    this.updateOptionTitle(option);
    this.updateFormData(option);
  }

  updateFormData(option) {
    if (this.cartForm) {
      const dataForm = JSON.parse(this.cartForm.getAttribute('data-form'));
      const items = Object.values(dataForm.items);
      const targetItem = items[0];

      if (targetItem) {
        const planName = option.getAttribute('data-plan-name');
        const parsedQuantity = this.parseQuantityFromPlanName(planName);
        
        const payload = {
          id: targetItem.id,
          quantity: parsedQuantity,
          ...(option.getAttribute('data-plan-id') && {
            selling_plan: option.getAttribute('data-plan-id'),
          }),
          properties: {},
        };

        this.cartForm?.formDataAPI?.updateItems(payload);
      }
    }
  }

  parseQuantityFromPlanName(planName) {
    if (!planName) return 1;
    
    const match = planName.match(/(\d+)\s*month/i);
    return match ? parseInt(match[1]) : 1;
  }

  observeCartFormChanges() {
    const observer = new MutationObserver(mutationsList => {
      for (const mutation of mutationsList) {
        if (mutation.type === 'attributes' && mutation.attributeName === 'data-product-card-selected_variant_id') {
          this.handleCartFormUpdate();
        }
      }
    });

    observer.observe(this.cartForm.querySelector("#product-card-section"), { attributes: true, attributeFilter: ['data-product-card-selected_variant_id'] });

    window.addEventListener('beforeunload', () => observer.disconnect());
  }

  handleCartFormUpdate() {
    const dataForm = JSON.parse(this.cartForm.getAttribute('data-form'));
    const variantId = Object.values(dataForm.items)?.[0]?.id;

    if (variantId) {
      this.classList.add("loading-plans");
      fetch(`${window.location.pathname}?variant=${variantId}`)
        .then(response => {
          if (!response.ok) throw new Error('Failed to fetch updated section');
          return response.text();
        })
        .then(html => {
          const parser = new DOMParser();
          const newDocument = parser.parseFromString(html, 'text/html');
          const newContent = newDocument.querySelector('subs-widget');

          if (newContent) {
            this.replaceWith(newContent);
          }
        })
        .catch(error => {
          console.error('Error updating section:', error);
        });
    }
  }
}

customElements.define('subs-widget', SubscriptionWidget);